module.exports = __webpack_public_path__ + "static/media/type.4becfe89.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/retained/type.png
// module id = 72
// module chunks = 0